/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { HomeRisk } from './homeRisk';
import { Invoice } from './invoice';
import { MotorRisk } from './motorRisk';
import { Participant } from './participant';
import { PartnershipCard } from './partnershipCard';
import { PaymentMethod } from './paymentMethod';
import { PremiumDiscount } from './premiumDiscount';
import { PremiumDiscountAmn } from './premiumDiscountAmn';
import { PremiumPaymentModality } from './premiumPaymentModality';

export interface QuotePolicy {
  homeRisks?: Array<HomeRisk>;
  motorRisks?: Array<MotorRisk>;
  riskType?: QuotePolicy.RiskTypeEnum;
  messagePolicyId?: string;
  messagePaymentId?: string;
  messageNotificationId?: string;
  tab?: QuotePolicy.TabEnum;
  /**
   * When QuotePolicy is a Project, this is the ProjectQuoteId
   */
  projectQuoteId?: string;
  branchDesc?: string;
  sectorDesc?: string;
  cancellationDate?: Date;
  expirationDate?: Date;
  effectiveDate?: Date;
  /**
   * Project capture Date
   */
  captureDate?: Date;
  userId?: string;
  actionId?: string;
  paymentMethod?: PaymentMethod;
  premiumPaymentModality?: PremiumPaymentModality;
  premiumDiscount?: PremiumDiscount;
  policyParticipants?: Array<Participant>;
  actions?: Array<QuotePolicy.ActionsEnum>;
  premiumDiscountAmn?: PremiumDiscountAmn;
  status?: QuotePolicy.StatusEnum;
  /**
   * When QuotePolicy is a Policy, this is the policyId
   */
  projectQuoteNumber?: string;
  version?: string;
  policyVersion?: string;
  customerRetentionLevel?: string;
  partnershipCard?: Array<PartnershipCard>;
  installmentInvoices?: Array<Invoice>;
  namedInsuredEqualOwner?: boolean;
  namedInsuredEqualDriver?: boolean;
  ownerEqualDriver?: boolean;
}
export namespace QuotePolicy {
  export type RiskTypeEnum = 'MOTOR' | 'HOME';
  export const RiskTypeEnum = {
    MOTOR: 'MOTOR' as RiskTypeEnum,
    HOME: 'HOME' as RiskTypeEnum,
  };
  export type TabEnum = 'QUOTE' | 'POLICY' | 'RENEWAL' | 'REMINDER';
  export const TabEnum = {
    QUOTE: 'QUOTE' as TabEnum,
    POLICY: 'POLICY' as TabEnum,
    RENEWAL: 'RENEWAL' as TabEnum,
    REMINDER: 'REMINDER' as TabEnum,
  };
  export type ActionsEnum =
    | 'CLAIM'
    | 'CAR_REP'
    | 'REQUEST_ASSISTANCE'
    | 'CHANGE_ADDRESS'
    | 'CHANGE_MIP'
    | 'SUSPENSION'
    | 'REACTIVATION';
  export const ActionsEnum = {
    CLAIM: 'CLAIM' as ActionsEnum,
    CARREP: 'CAR_REP' as ActionsEnum,
    REQUESTASSISTANCE: 'REQUEST_ASSISTANCE' as ActionsEnum,
    CHANGEADDRESS: 'CHANGE_ADDRESS' as ActionsEnum,
    CHANGEMIP: 'CHANGE_MIP' as ActionsEnum,
    SUSPENSION: 'SUSPENSION' as ActionsEnum,
    REACTIVATION: 'REACTIVATION' as ActionsEnum,
  };
  export type StatusEnum =
    | 'VALIDO'
    | 'SCADUTO'
    | 'NON_VALIDO'
    | 'APPENDICE'
    | 'ACQUISTATA'
    | 'ATTIVA'
    | 'CANCELLATA'
    | 'SOSPESA'
    | 'INSOLUTO';
  export const StatusEnum = {
    VALIDO: 'VALIDO' as StatusEnum,
    SCADUTO: 'SCADUTO' as StatusEnum,
    NONVALIDO: 'NON_VALIDO' as StatusEnum,
    APPENDICE: 'APPENDICE' as StatusEnum,
    ACQUISTATA: 'ACQUISTATA' as StatusEnum,
    ATTIVA: 'ATTIVA' as StatusEnum,
    CANCELLATA: 'CANCELLATA' as StatusEnum,
    SOSPESA: 'SOSPESA' as StatusEnum,
    INSOLUTO: 'INSOLUTO' as StatusEnum,
  };
}
